export const SAVE_BUTTON_TEXT = `שמירה`